import {Component, OnInit, Input, Output, EventEmitter, HostBinding, ViewChild} from '@angular/core';

@Component({
	selector: "cp-button",
	templateUrl: "./button.component.html",
	styleUrls: ["./button.component.scss"]
})
export class ButtonComponent implements OnInit {
	@Input() captionToTranslate: string;
	@Input() translationParameters: any[];
	@Input() iconName: string;
	@Input() type: "button" | "submit" = "button";
	@Input() accessibleLabel: string = null;

	@ViewChild("buttonElement", { static: false }) public buttonElement;

	@HostBinding("class.disabled") @Input() disabled: boolean;

	@Output() onClick: EventEmitter<void> = new EventEmitter<void>();

	constructor() { }

	ngOnInit() {

	}

	public clickHandler() {
		if (!this.disabled) {
			this.onClick.emit();
		}
	}
}

